import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { BehaviorSubject } from 'rxjs';
import { AuthNewService } from '../../../service/auth-new.service';

@Component({
  selector: 'app-user-sign-in',
  templateUrl: './user-sign-in.component.html',
  styleUrls: ['./user-sign-in.component.scss']
})
export class UserSignInComponent implements OnInit {

  signinForm!: FormGroup;
  codeForm!: FormGroup;
  submitted = false;
  username!: string;
  password!: string;
  code!: string;
  user!: CognitoUser;
  userAuthenticated = false;
  mfaFlag = false;
  userGroup = new BehaviorSubject<string>('');
  hide = true;
  error

  constructor(public formBuilder: FormBuilder, public router: Router, private authservice: AuthNewService) { }

  ngOnInit(): void {
    this.signinForm  =  this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.codeForm  =  this.formBuilder.group({
      code: ['', Validators.required]
    });
  }
  get formControls() { return this.signinForm.controls; }
  get formControls1() { return this.codeForm.controls; }

  signInNew() {
    this.submitted = true;
    this.userAuthenticated = false;
      if (this.signinForm.invalid) {
        return;
      }
      // console.log(JSON.stringify(this.signinForm.value, null, 2));
      this.username = this.signinForm.value.username;
      this.password = this.signinForm.value.password;
      // Should we just use signIn from Amplify directly here?
      this.authservice.handleSignIn(this.username, this.password).then(result => {
        if (result.Status === "MFA") {
          this.mfaFlag = true;
        } else if (result.Status === "NEW_PASSWORD") {
          this.router.navigate(['/extra-layout/new-password']);
        } else if (result.Status === "SUCCESS") {
          if (sessionStorage.getItem('access') == 'QA') {
            this.router.navigate(['default-layout/audit-trail'])
          } else {
            this.router.navigate(['default-layout/dashboard'])
          }
        } else {
          this.submitted = false;
            this.error = 'Username or Password is incorrect';
        }
      });
//       this.authservice.signinError.subscribe((error) => {
//         if (error) {
//           this.submitted = false;
//           this.error = 'Username or Password is incorrect.'
//         } else {
//           this.error = '';
//         }
//       })
//       this.authservice.user.subscribe((user: any) => {
//         if (user) {
//           // console.log(user);
//           if (user.challengeName === 'SMS_MFA') {
//             this.mfaFlag = true;
//           } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
//             this.router.navigate(['/extra-layout/new-password']);
//           } else if (sessionStorage.getItem('access') == 'QA') {
//             this.router.navigate(['default-layout/audit-trail'])
//           } else {
//            this.router.navigate(['default-layout/dashboard'])
//           }
//         }
//       })
  }

  confirmationCode() {
    this.code = this.codeForm.value.code;
    this.authservice.handleConfirmCode(this.code).then(data => {
      if (data.isSignedIn) {
        this.router.navigate(['default-layout/dashboard']);
      }
    }).catch(error => {
      console.log(error);
    });
//     this.authservice.user.subscribe((newUser: any) => {
//       if(newUser.signInUserSession) {
//         this.userAuthenticated = true;
//         this.user = newUser;
//         console.log('user', this.user)
//       } else {
//         console.log('error');
//       }
//       if (this.userAuthenticated) {
//         this.router.navigate(['default-layout/dashboard'])
//       }
//     });
  }
}
